
export const Consts ={
    loc:{pA:'premiApp',pS:'premiScr'}
}